<template>
  <div>
    <!-- 写跟进 弹屏 -->
    <a-modal
      v-model="isFollow"
      destroyOnClose
      :footer="null"
      :maskClosable="false"
      :closable="false"
      :width="700"
      centered
    >
      <div class="content-follow">
        <div class="title">
          <a-icon @click="isFollowFn" style="font-size: 16px; cursor: pointer" type="close" />
          <span>写跟进</span>
          <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="followOK">提交</span>
        </div>
        <textarea
          class="textarea"
          v-model="followUpAddData.followUpContent"
          @change="contentChange"
          placeholder="请输入跟进内容"
          :maxlength="100"
        ></textarea>
        <p style="color: #f6222d; height: 10px"><span v-if="isContent"> 请输入跟进内容</span></p>
        <div class="chooseBtn">
          <a-icon style="font-size: 18px; margin-right: 10px" type="plus-circle" />
          <span @click="addRemind" style="cursor: pointer">添加提醒</span>
        </div>
        <!-- 提醒内容 -->
        <div class="remind" v-for="(v, i) in followUpAddData.followUpNotifyBoList" :key="i">
          <div>
            <div class="col">
              <span style="margin-right: 10px; font-weight: bold; width: 60px">提醒对象</span>
              <!-- <a-select class="one" v-model="v.deptId" placeholder="部门" @change="chooseDept(i)">
                <a-select-option :value="item.deptId" v-for="item in dept" :key="item.deptId"
                  >{{ item.deptName }}
                </a-select-option>
              </a-select> -->
              <a-tree-select
                v-model="v.deptId"
                style="width: 150px"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="deptOptions"
                placeholder="部门"
                :replaceFields="replaceFields"
                tree-default-expand-all
              >
              </a-tree-select>

              <a-select
                class="one"
                placeholder="成员"
                v-model="v.userId"
                @dropdownVisibleChange="handleOption(i, $event)"
              >
                <a-select-option :value="item.userId" v-for="item in userList" :key="item.userId"
                  >{{ item.nickName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div>
            <div class="col">
              <span style="margin-right: 10px; font-weight: bold; width: 60px">提醒时间</span>
              <a-date-picker
                v-model="v.remindTime"
                showTime
                placeholder="请选择日期"
                :disabled-date="disabledStartDate"
              >
              </a-date-picker>
            </div>
          </div>

          <div class="col col-icon">
            <a-icon style="font-size: 20px" type="close-circle" @click="reduceRemind(v, i)" />
          </div>
        </div>
        <textarea
          style="height: 90px"
          class="textarea"
          v-model="notifyContent"
          placeholder="请输入提醒内容"
          :maxlength="100"
        ></textarea>
      </div>
    </a-modal>
  </div>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import { treeselect } from '@/api/system/dept' //---mixin
import { mapGetters } from 'vuex'
import { userSeeRecord } from '@/api/system/houses/house.js'

import moment from 'moment'

export default {
  props: {
    isFollow: {
      type: Boolean,
      require: true,
    },
    resourceId: {
      type: Number,
      require: true,
    },
    resourceType: {
      type: String,
      require: true,
    },
    rentSaleType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 写跟进的参数
      followUpAddData: {
        accessoryIds: '',
        followUpContent: '', // 跟进内容
        followUpNotifyBoList: [
          {
            deptId: undefined,
            remindTime: '',
            userId: undefined,
            notifyContent: '',
          },
        ],
        followUpResource: 'N', //跟进入口（是否是查看业主/客户后进行填写的跟进） 字典表类型：sys_yes_no ->Y/N
        followUpType: '1', // 跟进类型 字典表类型：follow_up_type
        rentSaleType: this.rentSaleType, //1租2售
        resourceId: this.resourceId, // 来源ID
        resourceType: this.resourceType,
        userSeeRecordId: '', //用户查看记录ID（是查看业主/客户后进行填写的跟进，则必填）
      },
      notifyContent: '',
      dept: [],
      userList: [],
      isContent: false,
      // 部门树选项
      deptOptions: [
        {
          id: 0,
          label: '',
          children: [],
        },
      ],
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' },
    }
  },
  methods: {
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeselect().then((response) => {
        this.deptOptions = response.data
      })
    },
    disabledStartDate(startValue) {
      // console.log(startValue.valueOf())
      // return startValue.valueOf() <= new Date().valueOf()//不能选择当天
      return startValue && startValue < moment().subtract(1, 'days').endOf('day') // 可以选择当天
    },
    // 关闭弹窗
    isFollowFn() {
      if (this.isfollowUpObj && this.isfollowUpObj.isFollowUp === 'N') {
        this.$message.warning('请完成跟进信息')
        return
      }
      this.followUpAddData.followUpContent = ''
      this.followUpAddData.followUpNotifyBoList = [
        {
          deptId: undefined,
          remindTime: '',
          userId: undefined,
          notifyContent: '',
        },
      ]
      this.notifyContent = ''
      this.followUpAddData.followUpResource = 'N'
      this.followUpAddData.userSeeRecordId = ''
      this.$emit('closeModal', false)
    },
    // 新增跟进记录=>发送请求
    followUpAdd() {
      //如果写跟进的来源为查看时，需添加下面两个参数
      if (this.isfollowUpObj && this.isfollowUpObj.isFollowUp === 'N') {
        this.followUpAddData.followUpResource = 'Y'
        this.followUpAddData.userSeeRecordId = this.isfollowUpObj.id
      }

      const { followUpContent } = this.followUpAddData
      if (!followUpContent) {
        this.$message.error('请输入跟进内容')
        return
      }
      // const isRemind = this.followUpAddData.followUpNotifyBoList.map((item) => {
      //   if (!item.deptId || !item.userId || !item.remindTime) {
      //     return false
      //   } else {
      //     return true
      //   }
      // })
      // console.log(isRemind)
      // if (isRemind.includes(false)) {
      //   this.$message.error('提醒对象请填写完整')
      //   return
      // }
      this.followUpAddData.resourceId = Number(this.$route.query.id)
      this.followUpAddData.followUpNotifyBoList = [...this.followUpAddData.followUpNotifyBoList].map((v) => {
        return {
          deptId: v.deptId,
          remindTime: v.remindTime ? this.$moment(v.remindTime).format('YYYY-MM-DD HH:mm:ss') : '',
          userId: v.userId,
          notifyContent: this.notifyContent,
        }
      })
      // console.log(this.followUpAddData,'this.followUpAddData')
      // return
      touristApi.followUpAdd({ ...this.followUpAddData }).then(async (res) => {
        if (res.code === 200) {
          if (this.isfollowUpObj && this.isfollowUpObj.isFollowUp === 'N') {
            let response = await userSeeRecord()
            if (response.code === 200) {
              this.$store.commit('SET_IS_FOLLOWUP_OBJ', response.data)
            }
          }
          this.isFollowFn()
          this.$message.success('新增跟进记录成功！')
          this.$emit('refresh')
        }
      })
    },
    // 增加提醒行
    addRemind() {
      if (this.followUpAddData.followUpNotifyBoList.length < 5) {
        this.followUpAddData.followUpNotifyBoList.push({
          deptId: undefined,
          remindTime: '',
          userId: undefined,
        })
      }
    },
    // 减少提醒行
    reduceRemind(v, index) {
      if (this.followUpAddData.followUpNotifyBoList.length > 1) {
        this.followUpAddData.followUpNotifyBoList.splice(index, 1)
      }
    },
    // 获取部门列表
    getDeptList() {
      touristApi.getDeptList().then((res) => {
        if (res.code === 200) {
          this.dept = res.data.map((item) => {
            return {
              deptId: item.deptId,
              deptName: item.deptName,
              leader: item.leader,
            }
          })
        }
      })
    },
    // 获取部门人员列表
    chooseDept(index) {
      this.followUpAddData.followUpNotifyBoList[index].userId = undefined
    },
    handleOption(index, e) {
      if (e) {
        const deptId = this.followUpAddData.followUpNotifyBoList[index].deptId
        if (deptId !== undefined) {
          touristApi.getUserList({ deptId: deptId }).then((res) => {
            if (res.code === 200) {
              this.userList = res.rows
            }
          })
        } else {
          this.userList = []
        }
      }
    },
    // 跟进===>提交
    followOK() {
      // console.log(this.followUpAddData)
      this.followUpAdd()
    },
    contentChange() {
      const { followUpContent } = this.followUpAddData
      if (!followUpContent) {
        this.isContent = true
      } else {
        this.isContent = false
      }
    },
    getPersonnel() {},
  },
  computed: {
    ...mapGetters(['isfollowUpObj']),
  },
  created() {
    this.getDeptList()
    this.getTreeselect()
  },
}
</script>

<style lang="less" scoped>
//跟进
.content-follow {
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .textarea {
    margin-top: 20px;
    width: 100%;
    height: 160px;
    border-radius: 10px;
    border-color: #f1f2f3;
    padding: 10px;
    margin-bottom: 20px;
    outline: none;
    resize: none;
    overflow: hidden;
  }

  .chooseBtn {
    display: flex;
    align-items: center;
    color: #33c171;
  }
  .remind {
    margin: 10px 0;
    display: flex;
    align-items: center;
    .col {
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
    .col-icon {
      justify-content: center;
      cursor: pointer;
    }
    .one {
      width: 120px;
    }
  }
}
</style>
